/**
 * devicePairing — einmaliger Token-Capture aus der URL.
 *
 * Beim ersten Aufruf einer TV-/Terminal-Seite kann der Admin die URL inkl.
 * `?pair=<token>` aufrufen. Dieser Helper:
 *  1. liest `pair` aus den Query-Params,
 *  2. speichert das Token in `localStorage.device_token`,
 *  3. ersetzt die URL (`history.replaceState`) so, dass das Token nicht mehr
 *     in der Adressleiste sichtbar ist,
 *  4. gibt das Token (oder das bestehende aus localStorage) zurueck.
 */
const STORAGE_KEY = 'device_token';

export function capturePairTokenFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const pair = params.get('pair');
    if (pair) {
      localStorage.setItem(STORAGE_KEY, pair);
      // ?pair=… aus der URL entfernen, hash bleibt
      params.delete('pair');
      const qs = params.toString();
      const clean = window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash;
      window.history.replaceState({}, '', clean);
      return pair;
    }
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function getDeviceToken() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearDeviceToken() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
